const SERVER_CONFIG_URL = "https://raw.githubusercontent.com/99techteam/kz-config/main/groups";
function serverConfigEndpoints(builder) {
  return {
    /**
     * Get the server config for a given group and accountId
     * Group level config: groups/<group>/<env>.json
     * Account level config: groups/<group>/<accountId>.<env>.json
     * Return group level config if underMaintenance is true OR not found, otherwise return account level config
     */
    getServerConfig: builder.query({
      providesTags: ["serverConfig"],
      queryFn: async ({ group, accountId, env }) => {
        const queryToken = (/* @__PURE__ */ new Date()).getTime();
        let groupConfig;
        try {
          groupConfig = await fetch(`${SERVER_CONFIG_URL}/${group}/${env}.json?t=` + queryToken, {
            cache: "no-store"
          }).then((res) => res.json());
          if (groupConfig == null ? void 0 : groupConfig.underMaintenance) {
            return {
              data: groupConfig
            };
          }
        } catch (error) {
        }
        try {
          const accountConfig = await fetch(`${SERVER_CONFIG_URL}/${group}/${accountId}.${env}.json?t=` + queryToken, {
            cache: "no-store"
          }).then((res) => res.json());
          if (!!accountConfig) {
            return {
              data: {
                ...groupConfig,
                ...accountConfig
              }
            };
          }
        } catch (error) {
        }
        return {
          data: {
            underMaintenance: false
          }
        };
      }
    })
  };
}
export {
  serverConfigEndpoints as default
};
